export const LABEL_BUSINESS_TURNOVER = "business_turnover";
